<template>
  <div class="gouvernance" id="gouvernance-list" @keyup.esc="toggleLayer(false)">
    <slot name="content" :openSlider="openSlider" />
    <template v-if="slideOpen">
      <div
        class="gouvernance-slider"
        id="governance-modal"
        tabindex="-1"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="computedAriaLabel"
      >
        <button
          type="button"
          id="close"
          class="btn-close"
          @click="toggleLayer(false)"
          ref="closeBtn"
        >
          {{ closeText }}
          <span class="btn--close" />
        </button>
        <div
          class="gouvernance-slider__top container--small"
          aria-roledescription="Carousel"
          role="group"
        >
          <button
            @click="mooveSlide(-2)"
            class="gouvernance-slider__nav gouvernance-slider__nav--prev"
          >
            <span class="off-screen">prev</span>
          </button>
          <ul class="gouvernance-slider__list">
            <li
              v-for="(item, index) in gouvernanceItems"
              :key="index"
              class="gouvernance-slider__item"
              :class="{
                'gouvernance-slider__item--selected': selected === index,
              }"
            >
              <button
                @click="changeItem(index)"
                :aria-selected="selected === index"
                :aria-label="item.firstName + ' ' + item.lastName"
              >
                <img :src="item.imgSmall" :alt="item.name" >
              </button>
            </li>
          </ul>
          <button
            @click="mooveSlide(2)"
            class="gouvernance-slider__nav gouvernance-slider__nav--next"
          >
            <span class="off-screen">next</span>
          </button>
        </div>
        <div class="gouvernance-slide" aria-roledescription="Slide">
          <div class="container--small" v-if="activeItem">
            <h2 class="gouvernance-slide__name" :id="computedAriaLabel">
              {{ activeItem.firstName }} {{ activeItem.lastName }}
            </h2>
            <div class="gouvernance-slide__content">
              <img
                src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
                v-srcset="activeItem.srcset"
                alt
                class="gouvernance-slide__image"
              >
              <div class="gouvernance-slide__left">
                <div
                  class="gouvernance-slide__position"
                  v-html="activeItem.position"
                />
                <div class="gouvernance-slide__copy" v-html="activeItem.copy" />
                <blockquote class="gouvernance-slide__quote">
                  {{ activeItem.quote }}
                </blockquote>
              </div>
            </div>
            <ul class="gouvernance-slide__social">
              <li v-for="(item, index) in activeItem.social" :key="index">
                <a
                  class="social-icon"
                  :href="item.link"
                  target="_blank"
                  :aria-label="
                    activeItem.firstName +
                      ' ' +
                      activeItem.lastName +
                      ' ' +
                      item.name
                  "
                >
                  <span class="icon" :class="'icon-' + item.icon" />
                  <span class="off-screen">{{ item.name }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import { fetchData } from '@Foundation/services';
  import { srcset } from '@Foundation/directives/srcset/srcset';
  import { tag } from '@Foundation/analyticsHandler/directives/tag.js';
  import { checkScreenSize } from '@Foundation/mixins/checkScreenSize';
  import { removePageScroll } from '@Foundation/mixins/removePageScroll';

  export default {
    name: 'gouvernance',
    directives: {
      tag,
      srcset,
    },
    mixins: [checkScreenSize, removePageScroll],
    props: {
      gouvernanceUrl: {
        type: String,
        default: null,
      },
      closeText: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        slideOpen: false,
        gouvernanceItems: [],
        activeItem: false,
        selected: false,
        popupNextValue: 0
      };
    },
    computed: {
      computedAriaLabel() {
        return this.activeItem && this.activeItem.firstName && this.activeItem.lastName ? `${this.activeItem.firstName} ${this.activeItem.lastName}` : '';
      }
    },
    methods: {
      openSlider(listValue) {
        this.slideOpen = true;
        this.popupNextValue = listValue;
        this.removePageScroll(true);
        fetchData(this.gouvernanceUrl).then((gouvernanceItems) => {
          var sizeList = document.querySelectorAll('.gouvernance-item').length;
          if (sizeList === gouvernanceItems.length) {
            this.selected = listValue - 1;
          } else {
            this.selected = listValue;
          }
          document
            .getElementById('main-container')
            .setAttribute('aria-hidden', 'true');
          this.gouvernanceItems = gouvernanceItems;
          this.$refs.closeBtn.focus();
          this.changeItem(this.selected);
          const focusableElements = ['button'];
          const modal = document.querySelector('#governance-modal'); // select the modal by it's id
          const firstFocusableElement =
            modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
          const focusableContent = modal.querySelectorAll(focusableElements);
          const lastFocusableElement =
            focusableContent[focusableContent.length - 1];
          document.getElementById('close').focus();
          // get last element to be focused inside modal
          document.addEventListener('keydown', function (e) {
            const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

            if (!isTabPressed) {
              return;
            }

            if (e.shiftKey) {
              // if shift key pressed for shift + tab combination
              if (document.activeElement === firstFocusableElement) {
                lastFocusableElement.focus(); // add focus for the last focusable element
                e.preventDefault();
              }
            } else {
              // if tab key is pressed
              if (document.activeElement === lastFocusableElement) {
                // if focused has reached to last focusable element then focus first focusable element after pressing tab
                firstFocusableElement.focus(); // add focus for the first focusable element
                e.preventDefault();
              }
            }
          });
        });
      },
      focusTrigger() {
        const modal = document.getElementById('gouvernance-list');
        if (modal) {
          const focusableElements = modal.querySelectorAll('.gouvernance-item .gouvernance-item__trigger');
          if (focusableElements.length >= this.popupNextValue) {
            focusableElements[this.popupNextValue - 1].focus();
          }
        }
      },
      toggleLayer(value) {
        this.slideOpen = value;
        this.removePageScroll(value);
        this.activeItem = false;
        document
          .getElementById('main-container')
          .setAttribute('aria-hidden', 'false');
        //new
        this.focusTrigger();
      },
      mooveSlide(value) {
        const list = document.querySelector('.gouvernance-slider__list');
        const initialScroll = list.scrollLeft;
        const slideSize = list
          .querySelector('.gouvernance-slider__item')
          .getBoundingClientRect().width;
        list.scrollLeft = initialScroll + (slideSize * value + 60);
      },
      changeItem(listValue) {
        this.activeItem = false;
        var nb = 4;
        var margin = 60;
        var spacing = 0;
        if (this.screenSize === 'small') {
          nb = 2;
          margin = 30;
          spacing = 100;
        }

        setTimeout(() => {
          this.activeItem = this.gouvernanceItems[listValue];
          this.selected = listValue;
          const list = document.querySelector('.gouvernance-slider__list');
          setTimeout(() => {
            if (listValue < nb) {
              list.scrollLeft = 0;
            } else {
              const slideSize = list
                .querySelector('.gouvernance-slider__item')
                .getBoundingClientRect().width;
              list.scrollLeft =
                (slideSize + margin) * (listValue - nb / 2) + spacing;
            }
          }, 1);
        }, 10);
      },
    },
  };
</script>

<style lang="scss" src="./gouvernance.scss"></style>
